import Vue from 'vue'
import VueScrollReveal from 'vue-scroll-reveal';

Vue.use(VueScrollReveal, {
    opacity: 0,
    distance: '100px',
    origin: 'bottom',
    duration: 800,
    mobile: false
})